import React from 'react'

export default function Calendar() {
  return (
    <div className="screen-container">Calendar</div>
  )
}
